"use client";

import { memo, useEffect } from "react";
import { getCookie, setCookie } from "@/commonJS/clientStorageActions";
import { nanoid } from "@reduxjs/toolkit";
import createApiClient from "@/commonJS/api";
const MainLayout = () => {
  const api = createApiClient();
  useEffect(() => {
    const GA_ID = process.env.NEXT_PUBLIC_GA_ID || "G-585LM7B0JH";
    if (typeof window !== "undefined") {
      import("react-ga4").then((ReactGA) => {
        ReactGA.default.initialize(GA_ID);
      });
    }
    let devCookie = getCookie("deviceId");
    if (devCookie === "") {
      let deviceId = nanoid();
      api
        .post(`/device/register`, {
          device_identifier: deviceId,
          device_type: "Web",
        })
        .then((res) => {
          if (res.data.code === 201 || res.data.code === 200) {
            setCookie("deviceId", res.data.data.device.identifier);
          } else {
          }
        })
        .catch((err) => {});
    }
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalOrganization",
          "name": "Medkart Pharmacy",
          "alternateName": "Medkart",
          "url": "https://www.medkart.in/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/logo1.webp"
          },
          "image": "https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset/medkart_store_1.webp",
          "description": "Medkart is a leading generic medicine pharmacy dedicated to reducing healthcare costs through high-quality, affordable medicines. Founded in 2014, with a mission to educate consumers about generic alternatives and promote informed healthcare choices, Medkart combines accessibility, transparency, and trust to serve millions of customers across India. Through its growing network of stores and online platform, Medkart continues to make quality healthcare more affordable and accessible for everyone.",
          "email": "Info@medkart.in",
          "foundingDate": "2014",
          "founder": [
            {
              "@type": "Person",
              "name": "Ankur Agarwal",
              "jobTitle": "Founder"
            },
            {
              "@type": "Person",
              "name": "Parasharan Chari",
              "jobTitle": "Co-founder"
            }
          ],
          "sameAs": [
            "https://in.linkedin.com/company/medkart-pharmacy",
            "https://www.instagram.com/medkartpharmacy/",
            "https://www.facebook.com/medkartpharmacy/",
            "https://www.youtube.com/c/MedkartPharmacy"
          ],
          "areaServed": {
            "@type": "Country",
            "name": "India"
          },
          "knowsAbout": [
            "Generic Medicines",
            "Affordable Healthcare",
            "Pharmacy Services",
            "Online Pharmacy",
            "Healthcare Cost Reduction"
          ]
        }),
        }}
      ></script>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "Medkart Pharmacy",
            operatingSystem: "Android, iOS",
            applicationCategory: "MedicalApplication",
            publisher: {
              "@type": "Organization",
              name: "Medkart Pharmacy",
              url: "https://www.medkart.in",
            },
            downloadUrl:
              "https://play.google.com/store/apps/details?id=in.medkart",
            installUrl:
              "https://apps.apple.com/in/app/medkart-pharmacy-generic-meds/id6443615062",
            screenshot: [
              "https://www.medkart.in/images/app-screenshot1.jpg",
              "https://www.medkart.in/images/app-screenshot2.jpg",
            ],
            description:
              "Medkart Pharmacy is an app offering affordable generic alternatives for your health essentials.",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "5",
              reviewCount: "100",
            },
          }),
        }}
      ></script> */}
    </>
  );
};
export default memo(MainLayout);
